/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Model_Access_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose who in your organization can select {name}." |
*
* @param {Model_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_access_description = /** @type {((inputs: Model_Access_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Access_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Legen Sie fest, wer in Ihrer Organisation ${i?.name} auswählen kann.`)
	return /** @type {LocalizedString} */ (`Choose who in your organization can select ${i?.name}.`)
});